import { jsx } from 'panel';
export function template() {
  return jsx("div", {
    sel: '.mp-text-highlight',
    class: {
      [this.attr("theme")]: true,
      ["size-".concat(this.attr("size"))]: true,
      ["length-".concat(this.attr("length"))]: true
    }
  }, jsx("div", {
    sel: '.text'
  }, this.attr("text")));
}